
import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from 'react-router-dom';

interface PolicyAcceptanceProps {
  termsChecked: boolean;
  privacyChecked: boolean;
  cookieChecked: boolean;
  onTermsChange: (checked: boolean) => void;
  onPrivacyChange: (checked: boolean) => void;
  onCookieChange: (checked: boolean) => void;
  className?: string;
  required?: boolean;
}

const PolicyAcceptance: React.FC<PolicyAcceptanceProps> = ({
  termsChecked,
  privacyChecked,
  cookieChecked,
  onTermsChange,
  onPrivacyChange,
  onCookieChange,
  className = "",
  required = true
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="terms" 
          checked={termsChecked} 
          onCheckedChange={onTermsChange} 
          required={required}
        />
        <label 
          htmlFor="terms" 
          className="text-sm text-gray-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          I agree to the <Link to="/terms" className="text-blue-600 hover:underline" target="_blank">Terms of Service</Link>
          {required && <span className="text-red-500">*</span>}
        </label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="privacy" 
          checked={privacyChecked} 
          onCheckedChange={onPrivacyChange} 
          required={required}
        />
        <label 
          htmlFor="privacy" 
          className="text-sm text-gray-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          I agree to the <Link to="/privacy" className="text-blue-600 hover:underline" target="_blank">Privacy Policy</Link>
          {required && <span className="text-red-500">*</span>}
        </label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="cookies" 
          checked={cookieChecked} 
          onCheckedChange={onCookieChange} 
          required={required}
        />
        <label 
          htmlFor="cookies" 
          className="text-sm text-gray-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          I agree to the <Link to="/cookie-policy" className="text-blue-600 hover:underline" target="_blank">Cookie Policy</Link>
          {required && <span className="text-red-500">*</span>}
        </label>
      </div>
    </div>
  );
};

export default PolicyAcceptance;
